require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-new-branch-hours-coming-soon.json") })
        }
      }, "path---articles-new-branch-hours-coming-soon");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-new-branch-hours-coming-soon!./.cache/json/articles-new-branch-hours-coming-soon.json
// module id = 1700
// module chunks = 231608221292675